// extracted by mini-css-extract-plugin
module.exports = {"Card":"DefaultPageLayout_Card__3CI1p","Card__content":"DefaultPageLayout_Card__content__1u0b6"};